// ツール共通UI設定。Node版とブラウザ完結版（VFS）の双方が同じJSONを正本として読む。
import path from 'node:path';
import { CONFIG_DIR } from './repo-paths.mjs';
import { readJson } from './json-utils.mjs';

let cachedConfig = null;

export function uiConfig() {
    if (!cachedConfig) cachedConfig = readJson(path.join(CONFIG_DIR, 'ui.json'));
    return cachedConfig;
}
